import type {ReactNode} from 'react';
import ReactMarkdown from 'react-markdown';
import {safeUrl} from '../constructor/productAdapter';

function flattenLinkText(value: ReactNode): string {
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (Array.isArray(value)) return value.map(flattenLinkText).join('');
  return '';
}
function responseLinkLabel(children: ReactNode, href: string, title?: string) {
  const supplied = flattenLinkText(children).trim();
  if (supplied && supplied !== href && !/^https?:\/\//i.test(supplied)) return supplied;
  if (title?.trim()) return title.trim();
  try {
    const url = new URL(href);
    const path = url.pathname.replace(/^\/+|\/+$/g, '').replace(/[-_]/g, ' ');
    return path ? `${url.hostname.replace(/^www\./, '')} · ${path}` : url.hostname.replace(/^www\./, '');
  } catch { return supplied || 'Open link'; }
}
function AssistantResponseLink({children, href, title}: {children?: ReactNode; href?: string; title?: string}) {
  const destination = safeUrl(href);
  if (!destination) return <>{children}</>;
  const label = responseLinkLabel(children, destination, title);
  return <span className="twe-drinks-advisor__response-link-row"><a className="twe-drinks-advisor__suggestion-tag" href={destination} target="_blank" rel="noopener noreferrer" title={title || label} aria-label={`${label} (opens in a new tab)`}>{label}</a></span>;
}
export function AssistantMarkdown({text, className = ''}: {text: string; className?: string}) {
  return <div className={`twe-drinks-advisor__prose${className ? ` ${className}` : ''}`}><ReactMarkdown components={{a: ({children, href, title}) => <AssistantResponseLink href={href} title={title}>{children}</AssistantResponseLink>}}>{text}</ReactMarkdown></div>;
}
